const Ferrari = [
    {
        ID: "ferrari_1",
        name: "F12 Berlinetta",
        brand: "Ferrari",
        price: 7.4,
        engine: "V12 6.3L",
        max: 340,
        version: "AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/2SwzRCC/f12f.webp",
        link: "/brands/ferrari/f12-berlinetta",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "ferrari_2",
        name: "LaFerrari",
        brand: "Ferrari",
        price: 33,
        engine: "V12 6.3L",
        max: 372,
        version: "AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/HY4Pqv8/la.webp",
        link: "/brands/ferrari/laferrari",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default Ferrari;
